import type { EmployeeDesignation, ExecutiveBriefingProfile } from '../types';
import { canAccessFullFinancesHub } from './contractorPayablesAccess';

/** Same gate as Firestore `canReadFinancesForecast` — admin, EA, CFO, COO, or CPA. */
export function canViewTeamCompensation(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
  briefingProfile?: ExecutiveBriefingProfile | null;
}): boolean {
  return canAccessFullFinancesHub(args);
}

export function canWriteTeamCompensation(args: {
  authRole: string | undefined;
}): boolean {
  return args.authRole === 'admin';
}
